module.exports = require('./Transform').EPSILON
